import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "open-in-new-window",
  "use": "open-in-new-window-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"open-in-new-window\">\n  <path d=\"M8 2v5h1V1H3l-.001 1H8zM7 3H1v6h6V3zM2 0h8v8H8v2H0V2h2V0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol